import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'
import getContent from 'pp-react-l10n'
import {
  Sheet,
  HeadingText,
  BodyText,
  Link,
  v2grey600,
  white,
  black,
  CloseIcon,
  V2CopyIcon,
  ShareFacebookIcon,
  ShareMessengerIcon,
  ShareTwitterIcon,
} from '@paypalcorp/pp-react'
const l10n = getContent('pages/seller/success')

const Container = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '21rem',
  // pp-react Sheet component needs a custom height for the design, otherwise it takes the full screen
  height: '21rem',
  background: white,
  borderRadius: 12,
  top: '50%',
  transform: 'translate(-50%, -50%)',
  '@media(max-width: 752px)': {
    transform: 'translateX(-50%)',
    top: 'auto',
    bottom: 0,
    borderRadius: '12px 12px 0 0',
  },
})

const Heading = css({
  marginTop: 80,
  textAlign: 'center',
  '@media(max-width: 752px)': {
    display: 'none',
  },
})

const MobileHeading = css({
  display: 'none',
  '@media(max-width: 752px)': {
    marginTop: 50,
    display: 'block',
  },
})

const SubContainer = glamorous.div({
  '@media(max-width: 752px)': {
    width: '70%',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  '@media(max-width: 425px)': {
    width: '90%',
  },
})

const SubHeading = css({
  marginTop: 16,
  width: '100%',
  color: v2grey600,
  textAlign: 'center',
  '@media(max-width: 752px)': {
    padding: '10px 20px 0',
  },
})

const Links = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  width: '100%',
})

const ShareLink = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 40,
})

const CloseBtn = css({
  position: 'absolute',
  right: 28,
  top: 28,
  padding: 5,
  cursor: 'pointer',
  ':hover': {
    '&::after': {
      content: `''`,
      width: 40,
      height: 40,
      background: black,
      opacity: '12%',
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      borderRadius: '50%',
    },
  },
  ':active': {
    '&::after': {
      opacity: '17%',
    },
  },
  '@media(max-width: 425px)': {
    right: 16,
    top: 16,
  },
})

ShareProfilePopup.propTypes = {
  isOpen: PropTypes.bool,
  handleDisplay: PropTypes.func,
}

ShareProfilePopup.defaultProps = {
  isOpen: false,
  handleDisplay: () => {},
}

function ShareProfilePopup(props) {
  return (
    <Sheet
      isOpen={props.isOpen}
      onClose={() => props.handleDisplay(false)}
      title={l10n('shareYourProfile')}
      containerClassName={`${Container}`}
      center
      noCloseButton
      hideTitle={true}
    >
      <CloseIcon
        size="sm"
        className={`${CloseBtn}`}
        onClick={() => props.handleDisplay(false)}
      />
      <HeadingText
        size="lg"
        role="heading"
        aria-level="1"
        className={`${Heading}`}
      >
        {l10n('popup.header')}
      </HeadingText>
      <HeadingText
        size="md"
        role="heading"
        aria-level="1"
        className={`${MobileHeading}`}
      >
        {l10n('popup.mobileHeader')}
      </HeadingText>
      <SubContainer>
        <BodyText className={`${SubHeading}`}>
          {l10n('popup.subheader')}
        </BodyText>
        <Links>
          <ShareLink title="Primary">
            <Link>
              <V2CopyIcon size="md" />
            </Link>
            {l10n('popup.copy')}
          </ShareLink>
          <ShareLink title="Primary">
            <Link>
              <ShareFacebookIcon size="md" />
            </Link>
            {l10n('popup.facebook')}
          </ShareLink>
          <ShareLink title="Primary">
            <Link>
              <ShareMessengerIcon size="md" />
            </Link>
            {l10n('popup.messenger')}
          </ShareLink>
          <ShareLink title="Primary">
            <Link>
              <ShareTwitterIcon size="md" />
            </Link>
            {l10n('popup.twitter')}
          </ShareLink>
        </Links>
      </SubContainer>
    </Sheet>
  )
}

export default ShareProfilePopup
